import {createAction} from '@reduxjs/toolkit'

export const updateSuggestedJourneys = createAction(
  'suggested_journeys/save',
  (data) => ({
    payload: data
  })
)
